import { IEligibilityCheck } from "eligibility/models";

const KW_LIMIT = 300;
const THERM_LIMIT = 40_000;

const esc = (v: unknown): string => {
  const s = v == null ? "" : String(v);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

const verdictLabel = (v: IEligibilityCheck["verdict"]): string =>
  v === "pass" ? "QUALIFIES" : v === "fail" ? "DOES NOT QUALIFY" : "NEEDS DATA";

const fmt = (v: number | null, digits = 1): string =>
  v == null ? "" : v.toFixed(digits);

// Ports the prototype's exportCsv: one row per statement plus a summary block.
export const buildEligibilityCsv = (check: IEligibilityCheck): string => {
  const header = [
    "Statement Date",
    "Account #",
    "Billing Period",
    "Billed Load (kW/kVA)",
    "Metered kW",
    "Therms",
    "Notes",
    "Source File",
  ];
  const body = check.statements.map((s) =>
    [
      s.statementDate,
      s.accountNumber,
      s.billingPeriod,
      s.billedLoadKw,
      s.meteredKw,
      s.therms,
      s.notes,
      s.sourceFileName,
    ]
      .map(esc)
      .join(",")
  );
  const summary = [
    `12-mo Avg Demand,${fmt(check.avgPeakDemandKw)},kW,(limit ${KW_LIMIT})`,
    `Annual Therms,${fmt(check.annualUsageTherms, 0)},,(limit ${THERM_LIMIT})`,
    `Direct Install,${verdictLabel(check.verdict)}`,
  ];
  return [header.join(","), ...body, "", ...summary].join("\n");
};

// Triggers a browser download of the CSV (thin, untested side-effect wrapper).
export const downloadEligibilityCsv = (check: IEligibilityCheck): void => {
  const blob = new Blob([buildEligibilityCsv(check)], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "direct_install_screen.csv";
  a.click();
  URL.revokeObjectURL(url);
};
